import axios, {type AxiosError} from 'axios';
import * as qs from 'qs';
import type {ApiError} from "./shared";

const apiUrl = import.meta.env.VITE_API_URL as string;

const publicApiClient = axios.create({
    baseURL: apiUrl,
    paramsSerializer: (params) => {
        return qs.stringify(params, {arrayFormat: 'comma'});
    },
});

publicApiClient.defaults.headers.common.Accept = 'application/json';

publicApiClient.interceptors.request.use(
    config => {
        const hash = window.location.hash.slice(1); // retire le '#'
        if (hash) {
            config.headers.Authorization = `Bearer ${hash}`;
        }
        return config;
    },
    error => Promise.reject(error)
);

publicApiClient.interceptors.response.use(
    response => response,
    (error: AxiosError<unknown>) => {
        let apiError: ApiError;
        if (error.response?.data && typeof error.response.data === 'object') {
            apiError = error.response.data as ApiError;
        } else {
            apiError = {
                code: 'unknown_error',
                message: error.message,
                error: 'unknown',
            };
        }
        return Promise.reject(apiError);
    }
);

export default publicApiClient;
